import { eventBus } from "../../utils/eventbus.util";
import { formatDigit } from "./format.util";

const Depth = ({ orders, side }) => {
  // Conditionally reverse orders if side is "sell"
  const displayOrders = side === "sell" ? [...orders].reverse() : orders;

  const handlerowclick = (quantity, price) => {
    if (side == "sell") {
      eventBus.emit("sellEvent", { quantity, price });
    } else {
      eventBus.emit("buyEvent", { quantity, price });
    }
  };

  return (
    <>
      <tbody>
        {displayOrders.length === 0 ? (
          <tr>
            <td colSpan={3} style={{ textAlign: "center" }}>
              No Data Found
            </td>
          </tr>
        ) : (
          displayOrders.map((data, i) => (
            <tr
              className="ng-scope text"
              key={i}
              style={{ cursor: "pointer" }}
              onClick={() => {
                handlerowclick(data.quantity, data.price);
              }}
            >
              <td
                className={`f-left ng-binding ${
                  side === "buy" ? "green" : "magenta"
                } ${side === "buy" ? "crypt-up" : "crypt-down"}`}
              >
                {formatDigit(data.price)}
              </td>
              <td className="f-left ng-binding">{data.quantity}</td>
              <td className="f-left ng-binding text-right">
                {formatDigit(data.total)}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </>
  );
};

export { Depth };
